
/* APPLICATION ROUTE CONSTANTS */
module.exports = Object.freeze({
  
    ROW_PER_PAGE : [10, 50, 100, 300, 500],

    // Status
    STATUS_REGISTER:'Register',

    /* Routers Link supplier_app */
    APP_HOME: '/applications',
    HOME: '/home',
    
    HOME_INTRO:'/logistics-intro',
    DASHBOARD: '/logistics-dashboard',
    INBOX: '/logistics-inbox',
    OUTBOX: '/logistics-outbox',

   /* Master */
   LOGISTICS_MASTER_VEHICLE_CREATE: '/vehicle-creation',
   LOGISTICS_MASTER_VEHICLE_LIST: '/vehicle-list',
   LOGISTICS_MASTER_VEHICLE_DETAILS: '/vehicle-details',

   /* Master */
   LOGISTICS_MASTER_DRIVER_CREATE: '/driver-creation',
   LOGISTICS_MASTER_DRIVER_LIST: '/driver-list',
   LOGISTICS_MASTER_DRIVER_DETAILS: '/driver-details',

   /* tansporter */
   LOGISTICS_TRANSPORT_REQUEST_CREATE:'/transport-request-creation',
   LOGISTICS_TRANSPORT_REQUEST_LIST:'/transport-request-list',
   LOGISTICS_TRANSPORT_REQUEST_DETAILS:'/transport-request-details',

   /* Master/Transporter */
   LOGISTICS_MASTER_TRANSPORTER_REGISTRATION: '/transporter-registration',
   LOGISTICS_MASTER_TRANSPORTER_LIST: '/transporter-list',
   LOGISTICS_MASTER_TRANSPORTER_DETAILS: '/transporter-details',

   //gate Entery
   LOGISTICS_IN_WORD_OUT_WORD_LIST: "/logistics-inward-outward-list",
   LOGISTICS_GATE_ENTRY_UPDATE: "/logistics-gate-details",

   //fuel Entry
   LOGISTICS_FUEL_ENTRY_LIST:"/logistics-fuel-entry-list",

   //Bunk 
   LOGISTICS_MASTER_BUNK_CREATE: '/bunk-creation',
   LOGISTICS_MASTER_BUNK_LIST: '/bunk-list',
   LOGISTICS_MASTER_BUNK_DETAILS: '/bunk-details',
   
   //Bank
   LOGISTICS_BANK_LIST:'/bank-list'
  





   






})  

